import script from "./search-result.vue?vue&type=script&setup=true&lang=js"
export * from "./search-result.vue?vue&type=script&setup=true&lang=js"

import "./search-result.vue?vue&type=style&index=0&id=51dfdb33&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51dfdb33"]])

export default __exports__